import { z } from "zod";

export const placeSchema = z.object({
  name: z.string().min(1, "Name is required"),
  status: z.enum(["available", "unavailable"], {
    errorMap: () => ({ message: "Status must be selected" }),
  }),
  type: z.string().min(1, "Type is required"),

  owner: z.object({
    L1: z.string().min(1, "L1 is required"),
    L2: z.string().optional(),
    L3: z.string().optional(),
    L4: z.string().optional(),
  }),

  parentId: z.string().optional(),

  detailedSettings: z.object({
    subPlaces: z
      .array(
        z.object({
          index: z.number().int().min(0, "Index must be 0 or greater"),
          title: z.string().min(1, "Title is required"),
          numberOfWinners: z
            .number()
            .int()
            .min(1, "Number of winners must be at least 1"),
          status: z.enum(["enabled", "disabled"]),
        }),
      )
      .default([]),
  }),
});
